<template>
  <div>
    <iframe ref="ketcherFrame" class="ketcher-frame" src="ketcher/index.html"></iframe>
  </div>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const ketcherFrame = ref(null) // iframe template ref

function setSmiles () {
  const ketcherInstance = ketcherFrame.value.contentWindow.ketcher
  ketcherInstance.getSmiles().then(smiles => {
    store.commit('smiles', smiles)
  })
}

defineExpose({ setSmiles })
</script>

<style scoped>
iframe.ketcher-frame {
  width: 100%;
  min-height: 450px;
  border: none;
  overflow: hidden;
  border-radius: 20px;
}
</style>
